import type { PreselectedWorkspaceProvider } from '@/features/iam/workspaces/PreselectedWorkspaceProvider'
import type { ReadPreselectedWorkspaceInfoFn } from '@/features/iam'

/**
 * Preselected workspace info, as read off the environment.
 */
export interface PreselectedWorkspaceInfo {
  id: string
  name: string
  primaryLogoUrl: string
  invertedPrimaryLogoUrl: string
  iconUrl: string
  invertedIconUrl: string
  isMagicLinkWorkspace: boolean
  allowRequestingMagicLinks: boolean
}

/**
 * Creates a preselected workspace info reader function.
 *
 * @param provider
 */
export function createPreselectedWorkspaceInfoReader(
  provider: PreselectedWorkspaceProvider,
): ReadPreselectedWorkspaceInfoFn {
  return (): PreselectedWorkspaceInfo | null => {
    const preselection = provider.read()
    if (preselection?.type === 'Url') {
      return {
        id: preselection.workspaceResource.id,
        name: preselection.workspaceResource.name,
        primaryLogoUrl: preselection.workspaceResource.branding.logos.primary,
        invertedPrimaryLogoUrl:
          preselection.workspaceResource.branding.logos.primary_white,
        iconUrl: preselection.workspaceResource.branding.logos.icon,
        invertedIconUrl:
          preselection.workspaceResource.branding.logos.icon_white,
        isMagicLinkWorkspace:
          Boolean(
            preselection.workspaceResource.config.external_customers_config
              ?.enabled,
          ) &&
          Boolean(
            preselection.workspaceResource.config.public_api_config
              ?.signed_url_enabled,
          ),
        allowRequestingMagicLinks: Boolean(
          preselection.workspaceResource.config.external_customers_config
            ?.allow_requesting_magic_links,
        ),
      }
    }

    return null
  }
}
